<!-- <app-header *ngIf="isSinglePage && isCareerPortal && selRoute != '/login'" class="layout-header"
    [menuToggleEnabled]="false" [isAuthorized]="false">
</app-header> -->
<dx-scroll-view [height]="selRoute == '/login' ? '100vh':'100%' " class="full-height-scrollable"
    [ngClass]="{'fixedHeight':isCareerPortal && selRoute !== '/login','fixedHeight1':!isCareerPortal}">
    <!--  [@routerTransition] -->
    <div class="content" [ngClass]="{'customeHeight':!isSelfOnboardProtal,'selfHeight':isSelfOnboardProtal}">
        <ng-content></ng-content>
    </div>
</dx-scroll-view>
<app-footer class="text-center bg-left-none mt80"
    *ngIf="isWhiteLabled == 'No' && selRoute !== '/login' && isCareerPortal">
    <div class="ess-fs-14 h-100 d-flex align-items-center justify-content-center px-2">
        <span class="mt-3 fz-12"><b>Powered By</b></span>
        <a [href]="footerLink ? footerLink : 'https://www.staffinggo.in/'" target="_blank" class="ess-fs-14 pl-2"> <img
                [src]="footerImg ? footerImg : 'assets/img/PoweredBy.png'" alt="PoweredBy" width="70px"
                class="img-responsive"></a><span class="pl-2 mt-3 fz-12">(v1.0.1)</span>
    </div>
</app-footer>